<template>
  <div class="navbar-fixed-content" style="padding-top:70px;">
    <my-account-header></my-account-header>
    <div class="myinfo-bottom">
      <div class="cnt">
        <my-side-menu></my-side-menu>

        <div class="myinfo-con">
          <div class="tabbable-line">
            <div class="tab-content tab-content-banji">
              <div class="tab-pane active">
                <div class="c-list">
                  <div v-for="(trainingItem,index1) in trainingLists">
                    <div class="top_kb_item" v-for="(trainItem,index2) in trainingItem.childs">
                      <span class="top_kb_user"></span>
                      <div class="top_kb_arrow"></div>
                      <div class="top_kb_i">
                        <a class="kb_video" @click="clickClassUrl(trainItem)" target="_blank">
                          <img :src="trainItem.logo" />
                        </a>
                        <div class="kb_fr" style="background: #fff;">
                          <div class="top_kb_desc" style="color:#333;">
                            <div class="top_kb_name" style="margin-top:0;">
                              <a @click="clickClassUrl(trainItem)" target="_blank">{{trainItem.name}}</a>
                            </div>
                            <div class="top_kb_date">
                              <img src="/Images/new/icon-timelong.png" />
                              {{trainItem.startTime | dateFormat("yyyy-mm-dd")}}-{{trainItem.endTime |
                              dateFormat("yyyy-mm-dd")}}
                            </div>
                            <div class="top_kb_date"
                              v-if="trainingTimeLists != undefined && trainingTimeLists[index1] != undefined && l_lst[index1]!= undefined">
                              直播课程已学
                              <span class="sum-live-time-3087"
                                style="color: #e51c23;">{{trainingTimeLists[index1][index2]}}/{{l_lst[index1][index2] }}</span>
                              课时 
                            </div>

                            <div class="top_kb_date"
                              v-if="courseTimeLists != undefined && courseTimeLists[index1] != undefined && r_lst[index1]!= undefined">
                              录播课程已学
                              <span class="sum-live-time-3087"
                                style="color: #e51c23;">{{courseTimeLists[index1][index2]}}/ {{r_lst[index1][index2]}}</span>
                              课时
                            </div>

                            <button type="button" class="downCertificate"
                              v-if="downloadActive != undefined && downloadActive[index1] != undefined&&trainItem.allowDownloadCertificate"
                              :style="{display:'block','padding': '7px 37px','margin-top': '12px','border': 'none','background': '#bd1b21','color': '#fff','border-radius': '2px','font-size': '16px','outline': 'none','width': '150px'}"
                              @click="downMyCretificate(trainItem)">下载证书</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row" style="with；100%;height:50px;margin-top:20px;">
                  <!-- v-if="query_data.PageIndex*query_data.MaxResultCount< query_data.totalCount" -->
                  <div class="col-md-12 loading-more" style="with；100%;height:50px; border: none;"
                    v-if=" query_data.MaxResultCount * query_data.PageIndex < query_data.totalCount"
                    @click="loadMore()">
                    加载更多
                  </div>
                </div>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :class="[showCertificate ? 'modal fade in' : 'modal fade']" id="showCertificate_shadow" tabindex="-1"
      role="dialog" :style="{display:(showCertificate==true?'block':'none'),'top':'70px'}">
      <div class="modal-dialog" role="document" style="width: 1280px;">
        <div class="modal-content">
          <div class="modal-body">
            <div class="Certificate-box">
              <div class="Certificatecenter">
                <h2>
                  预览证书
                  <button class="down_Certificate" @click="clickGeneratePicture()">证书下载</button>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    @click.stop="fadeMyCretificate()">
                    <span aria-hidden="true">X</span>
                  </button>
                </h2>
                <div class="imgdom" id="imageDom" ref="imageDom"
                  style="background:url('/Images/Certificate.jpg') no-repeat;">
                  <img :src="credent_img" oncontextmenu="return false" onselectstart="return false" />
                  <span class="username" :class="[cId==3087?'':'cls1']">
                    <span class="username1" style="border-bottom: 1px solid;padding: 0 18px;"
                      :style="{'border-bottom':(cId==3087?'1px solid':'0'),'margin-left':(cId==3088?'-40px':'0px')}">{{userInfo.name}}</span>
                    {{cId==3087?'同志 :':''}}
                  </span>
                  <span class="studytime" :class="[cId==3087?'cls2_1':'cls2']">{{datebt}}</span>
                  <span class="studytime"
                    style="position: absolute;top: 444px;left: 120px;font-size: 34px;font-family: serif;">{{classname}}</span>
                  <span class="studytime" :class="[cId==3087?'cls3_1':'cls3']">{{cId==3088?'':record}}</span>
                  <span class="studytime"
                    style="position: absolute;top: 503px;left: 330px;font-size: 34px;font-family: serif;"
                    v-show="cId!=3087">{{cId==3088?'':rate}}</span>
                  <span class="studytime"
                    style="position: absolute;top: 503px;left: 753px;font-size: 34px;font-family: serif;">{{excellentOrQulified}}</span>
                  <span class="stunumber"
                    :style="{'margin':(cId==3088?'0px 0px -34px 15px':'0px')}">{{certificateNum}}</span>

                  <span class="studytime"
                    style="position: absolute;top: 700px;left: 900px;font-size: 34px;font-family: serif;">{{servertime}}</span>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div :class="[showCertificate ? 'modal-backdrop fade in' : '']" @click="fadeMyCretificate()"></div>
  </div>
</template>
<style>
.imgdom .cls1 {
  position: absolute;
  top: 310px;
  left: 176px;
  font-size: 30px;
  color: #000;
  font-weight: 500;
}

.imgdom .cls2_1 {
  position: absolute;
  top: 350px;
  left: 160px;
  font-size: 30px;
  color: #000;
  font-weight: 500;
}

.imgdom .cls2 {
  position: absolute;
  top: 391px;
  left: 240px;
  font-size: 30px;
  color: #000;
  font-weight: 500;
}

.imgdom .cls3_1 {
  position: absolute;
  top: 448px;
  left: 320px;
  font-size: 30px;
  color: #000;
  font-weight: 500;
}

.imgdom .cls3 {
  position: absolute;
  top: 503px;
  left: 154px;
  font-size: 30px;
  color: #000;
  font-weight: 500;
}
</style>
<script>
import MyAccountHeader from "@/layout/MyAccountHeader";
import MySideMenu from "@/layout/MySideMenu";
import html2canvas from "html2canvas"
import CourseDetail from "@/pages/CourseDetail";
import comFun from "@/common/common";
export default {
  components: {
    MyAccountHeader,
    MySideMenu,
  },
  data() {
    return {
      query_data: {
        stopajax: !1,
        MaxResultCount: 5,
        Sorting: "StartTime DESC,Id DESC",
        status: 0,
        PageIndex: 0,
        totalCount: 0,
        index: 0,
        SkipCount: 0,
      },
      imgUrl: 'http://bj.bcebos.com/v1/spzxpublic/PeiXun/Image/ae85558a5c8c4a81b99927824bfb214a/7a0e4b28-e2fe-492a-9dd8-b6dea5be0dbc.jpg',
      trainingTimeLists: [],
      courseTimeLists: [],
      trainingLists: [],
      downloadActive: [],
      r_lst: [],
      l_lst: [],
      cId: 0,
      credent_img: '/images/Certificate.jpg',
      showCertificate: false,
      certificateNum: '',/*证书编号*/
      record: 0,/*学时*/
      classname: '',/*班级名称*/
      excellentOrQulified: '',/*优秀 合格 不合格*/
      datebt: '',/*学习期间*/
      servertime: '',/*证书发证时间 已服务器时间为准*/
      rate: 0/*学习时间和学时的转换率*/
    };
  },
  filters: {
    dateFormat(dateStr, pattern = "") {
      var dt = new Date(dateStr);
      var yy = dt.getFullYear();
      var mm = (dt.getMonth() + 1).toString().padStart(2, "0");
      var dd = dt.getDate().toString().padStart(2, "0");
      var h = dt.getHours().toString().padStart(2, "0");
      var m = dt.getMinutes().toString().padStart(2, "0");
      var s = dt.getSeconds().toString().padStart(2, "0");
      if (pattern.toLowerCase() === "yyyy-mm-dd") {
        return yy + "年" + mm + "月" + dd + "日";
      } else if (pattern.toLowerCase() === "yyyy-mm-dd hh:mm") {
        return yy + "-" + mm + "-" + dd + " " + h + ":" + m;
      } else if (pattern.toLowerCase() === "hh:mm") {
        return h + ":" + m;
      } else {
        return yy + "-" + mm + "-" + dd + " " + h + ":" + m + ":" + s;
      }
    },
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    nav() {
      return this.$store.state.nav;
    },
  },
  created() {
    this.loadMore();
  },
  mounted() {
    // this.loadMore()
    // this.loadMore();
  },
  methods: {
    loadMore: function () {
      // 获取全部

      comFun.getMyTrainingLists(this.query_data).then((res) => {
        const arr = [];
        var list = [];
        if (res.items) {
          res.items.forEach((item) => {
            const parent = arr.find((cur) => {
              var str = cur.year + cur.month;
              var str1 = item.year + item.month;
              return str == str1;
            });
            if (parent) {
              parent.childs.push(item);
            } else {
              const obj = {
                year: item.year,
                month: item.month,
                id: item.id,
                childs: [item],
              };
              arr.push(obj);
              list = arr
              // this.trainingLists = arr;
            }
          });
          this.trainingLists = this.trainingLists.concat(list)
          this.getMyTrainingTimes(list);
          this.getMyCourseTimes(list);
          // this.getMyTrainingTimes(this.trainingLists);
          // this.getMyCourseTimes(this.trainingLists);

          this.query_data.totalCount = res.totalCount;
          if (this.query_data.PageIndex * this.query_data.MaxResultCount < this.query_data.totalCount) {
            this.query_data.PageIndex = this.query_data.PageIndex + 1;
          } else {
            this.query_data.stopajax = 1;
          }
        }
      });
    },
    clickClassUrl(item) {
      this.$router.push({
        name: "ClassDetail",
        query: {
          id: item.id,
        },
      });
    },

    async getMyCourseTimes(dataLists) {
      var tmp = []
      for (let i = 0; i < dataLists.length; i++) {
        var timeItem = [];
        var r_item = [];
        let item1 = dataLists[i].childs;

        for (let j = 0; j < item1.length; j++) {
          let res = await comFun.getMyCourseTime(
            item1[j].id,
            this.userInfo.id
          );
          if (res.success) {
            timeItem.push(res.result);
          }

          let r_res = await comFun.getTotal(item1[j].id, 0);
          r_item.push(r_res.result);
        }
        this.courseTimeLists.push(timeItem);
        // this.r_lst.push(r_item);
        tmp.push(r_item)
      }
      this.r_lst = this.r_lst.concat(tmp)

    },

    async getMyTrainingTimes(dataLists) {
      var tmp = []
      for (let i = 0; i < dataLists.length; i++) {
        var timeItem = [];
        var isActive = [];
        let item1 = dataLists[i].childs;
        var l_item = [];

        for (let j = 0; j < item1.length; j++) {
          let res = await comFun.getMyTrainingTime(
            item1[j].id,
            this.userInfo.id
          );
          if (res.success) {
            timeItem.push(res.result);
            if (item1[j].id == 3087) {
              if (res.result > 48) {
                let ress = await comFun.getMyClassConsequentCount(item1[j].id);
                if (ress.result > 0) {
                  isActive.push("1");
                }
              }
            } else {
              isActive.push("0");
            }
          }

          let l_res = await comFun.getTotal(item1[j].id, 1);
          l_item.push(l_res.result);
        }
        this.trainingTimeLists.push(timeItem);
        this.downloadActive.push(isActive);
        // this.l_lst.push(l_item);
        tmp.push(l_item)
      }
      this.l_lst = this.l_lst.concat(tmp)
      
    },
    fadeMyCretificate() {
      this.showCertificate = !this.showCertificate;

    },
    /*
    downMyCretificate(item) {
      comFun.getMyClassNumber(item.id).then(res =>{
        if(res.success){
          var num = (Array(4).join(0) + res.result).slice(-4);
          this.certificateNum = 'TJSPZX2020001' + num;
          this.showCertificate = !this.showCertificate;
        }
      });
    },
    */

    downMyCretificate(item) {
      this.cId = item.id
      if (item.id == 3087) {//国际“双元制”职业教育专题培训 专用
        comFun.getMySpecialClassNumber(item.id).then(res => {
          if (res.success) {
            var num = (Array(4).join(0) + res.result).slice(-4);
            this.certificateNum = 'TJSPZX2020001' + num;
            this.showCertificate = !this.showCertificate;
            this.credent_img = '/images/Certificate_old.jpg';
            this.datebt = '';
            this.rate = '';
            this.classname = '';
            this.excellentOrQulified = '';
            this.record = 48;
            this.servertime = ''
          }
        });
      }
      else if (item.id == 3088) {//2020年国家级职业教育教师教学创新团队
        comFun.getMyClassNumber(item.id).then(res => {
          if (res.success) {
            if (res.result.success == 'true') {
              this.credent_img = '/images/Certificate_special.jpg';
              this.certificateNum = 'TJSPZX' + new Date().getFullYear().toString() + res.result.credent;
              /*this.datebt=res.result.datebt;
              this.rate=res.result.rate;
              this.classname=res.result.classname;
              this.excellentOrQulified=res.result.excellentOrQulified;
              this.record=res.result.record;
              this.servertime=res.result.servertime;*/
              this.showCertificate = !this.showCertificate;
            } else {
              alert(res.result.reason);
            }
          }
        });
      }
      else {
        comFun.getMyClassNumber(item.id).then(res => {
          if (res.success) {
            if (res.result.success == 'true') {
              this.certificateNum = 'TJSPZX' + new Date().getFullYear().toString() + res.result.credent;
              this.datebt = res.result.datebt;
              this.rate = res.result.rate;
              this.classname = res.result.classname;
              this.excellentOrQulified = res.result.excellentOrQulified;
              this.record = res.result.record;
              this.servertime = res.result.servertime;
              this.showCertificate = !this.showCertificate;
            } else {
              alert(res.result.reason);
            }
          }
        });
      }

    },
    clickGeneratePicture() {
      setTimeout(() => {
        //window.pageYOffset = 0;
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        html2canvas(this.$refs.imageDom).then((canvas) => {
          // 转成图片，生成图片地址
          this.imgUrl = canvas.toDataURL("image/png"); //可将 canvas 转为 base64 格式
          this.downImg(this.imgUrl);
        });
      }, 1000);
    },
    downImg(url) {
      // 下载
      if (window.navigator.msSaveOrOpenBlob) {
        let bstr = atob(url.split(",")[1]);
        let n = bstr.length;
        let u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        let blob = new Blob([u8arr]);
        window.navigator.msSaveOrOpenBlob(blob, "Certificate" + "." + "png");
      } else {
        fetch(url).then((res) =>
          res.blob().then((blob) => {
            let link = document.createElement("a");
            link.download = "Certificate" + ".png";
            link.href = window.URL.createObjectURL(blob);
            link.style.display = "none";
            link.click();
            window.URL.revokeObjectURL("Certificate" + ".png");
          })
        );
      }
    },
  },
};
</script>


